import React from 'react';
import styles from '../Footer.module.scss';

const HireExperts = () => {
  return (
    <ul className={styles.footerList}>
      <li className={styles.subTitle}>
        <a href="/hire-a-freelancer">
          <strong>Hire Experts</strong>
        </a>
      </li>
      <li>
        <a href="/howitworks">How it Works</a>
      </li>
      <li>
        <a href="/post-a-job">Post a Job</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/video-and-animation">
          Hire Video &amp; Animation Experts
        </a>
      </li>
      <li>
        <a href="/hire-a-freelancer/programming">Hire Developers</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/graphic-design">Hire Designers</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/music">Hire Music &amp; Audio Experts</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/digital-marketing">
          Hire Marketing Experts
        </a>
      </li>
      <li>
        <a href="/hire-a-freelancer">Hire Experts Worldwide</a>
      </li>
    </ul>
  );
};

export default HireExperts;
